import Filter from "@mui/icons-material/FilterAltTwoTone";
import { Badge, css, IconButton, Popover } from "@mui/material";
import { useRef, useState } from "react";
import { FlexColContainer } from "./layout";

interface FilterDropdownProps {
  activeFilterCount: number;
  children: React.ReactNode;
}

export const FilterDropdown = ({
  activeFilterCount,
  children,
}: FilterDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={() => setIsOpen((prev) => !prev)}
        sx={{ borderRadius: "6px" }}
        title="Filter annotations"
      >
        <Badge
          badgeContent={activeFilterCount}
          color="primary"
          invisible={activeFilterCount === 0}
        >
          <Filter sx={{ height: "24px" }} />
        </Badge>
      </IconButton>
      <Popover
        open={isOpen}
        anchorEl={anchorRef.current}
        onClose={() => setIsOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{
          paper: {
            sx: { overflow: "visible" },
          },
        }}
      >
        <FlexColContainer
          css={({ spacing }) => css`
            padding: ${spacing(2)};
            gap: ${spacing(2)};
            min-width: 300px;
          `}
        >
          {children}
        </FlexColContainer>
      </Popover>
    </>
  );
};
